import type { AgentVersionSummary } from '@frontend/types';

// ============================================================================
// State Types
// ============================================================================

export type Selection = {
  versionNumber: number;
  versionSummary: AgentVersionSummary;
} | null;

export type VersionToRestore = {
  version: AgentVersionSummary;
  displayLabel: string | number;
} | null;

export type State = {
  selection: Selection;
  restoreDialog: {
    isOpen: boolean;
    versionToRestore: VersionToRestore;
  };
};

export const initialState: State = {
  selection: null,
  restoreDialog: { isOpen: false, versionToRestore: null },
};

// ============================================================================
// Actions
// ============================================================================

export type Action =
  | { type: 'SELECT_VERSION'; versionNumber: number; versionSummary: AgentVersionSummary | null }
  | { type: 'RESET_SELECTION' }
  | { type: 'OPEN_RESTORE_DIALOG'; version: AgentVersionSummary; displayLabel: string | number }
  | { type: 'CLOSE_RESTORE_DIALOG' }
  | { type: 'RESTORE_SUCCESS' };

// ============================================================================
// Reducer
// ============================================================================

export function reducer(state: State, action: Action): State {
  switch (action.type) {
    case 'SELECT_VERSION':
      return {
        ...state,
        selection: action.versionSummary
          ? { versionNumber: action.versionNumber, versionSummary: action.versionSummary }
          : null,
      };
    case 'RESET_SELECTION':
      return { ...state, selection: null };
    case 'OPEN_RESTORE_DIALOG':
      return {
        ...state,
        restoreDialog: {
          isOpen: true,
          versionToRestore: { version: action.version, displayLabel: action.displayLabel },
        },
      };
    case 'CLOSE_RESTORE_DIALOG':
      return { ...state, restoreDialog: initialState.restoreDialog };
    case 'RESTORE_SUCCESS':
      return { ...state, selection: null, restoreDialog: initialState.restoreDialog };
    default:
      return state;
  }
}
